// extracted by mini-css-extract-plugin
module.exports = {"footerMethodsList":"FooterMethodsList_footerMethodsList__32VMY"};